import PropTypes from "prop-types";
import { pluck } from "ramda";
import React from "react";
import Select from "react-select";

export const CountrySelect = ({
  value,
  onChange,
  isMulti,
  className,
  options = [],
  isLoading = false,
}) => {
  const handleChange = (input) => {
    if (isMulti) {
      const country = pluck("value", input || []);
      onChange(country);
    } else {
      onChange(input?.value);
    }
  };

  return (
    <Select
      isClearable
      isMulti={isMulti}
      isLoading={isLoading}
      options={options}
      value={
        !value ? null : options.find((item) => item.value === value) ?? null
      }
      onChange={handleChange}
      className={className}
    />
  );
};

CountrySelect.propTypes = {
  isMulti: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};
